import { createContext } from "react";
import { initialStateProps } from "./initial-context-props";
export var SessionContext = createContext(initialStateProps);
export default SessionContext;
